import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

function Slider({
    className,
    defaultValue,
    value,
    min = 0,
    max = 100,
    ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
    const _values = React.useMemo(
        () => (Array.isArray(value) ? value : Array.isArray(defaultValue) ? defaultValue : [min, max]),
        [value, defaultValue, min, max]
    );

    return (
        <SliderPrimitive.Root
            data-slot="slider"
            defaultValue={defaultValue}
            value={value}
            min={min}
            max={max}
            className={cn(
                "setu:relative setu:flex setu:w-full setu:touch-none setu:items-center setu:select-none setu:data-[disabled]:opacity-50 setu:data-[orientation=vertical]:h-full setu:data-[orientation=vertical]:min-h-44 setu:data-[orientation=vertical]:w-auto setu:data-[orientation=vertical]:flex-col",
                className
            )}
            {...props}
        >
            <SliderPrimitive.Track
                data-slot="slider-track"
                className={cn(
                    "setu:bg-muted setu:relative setu:grow setu:overflow-hidden setu:rounded-full setu:data-[orientation=horizontal]:h-1.5 setu:data-[orientation=horizontal]:w-full setu:data-[orientation=vertical]:h-full setu:data-[orientation=vertical]:w-1.5"
                )}
            >
                <SliderPrimitive.Range
                    data-slot="slider-range"
                    className={cn(
                        "setu:bg-primary setu:absolute setu:data-[orientation=horizontal]:h-full setu:data-[orientation=vertical]:w-full"
                    )}
                />
            </SliderPrimitive.Track>
            {Array.from({ length: _values.length }, (_, index) => (
                <SliderPrimitive.Thumb
                    data-slot="slider-thumb"
                    key={index}
                    className="setu:!border-primary setu:bg-background setu:ring-ring/50 setu:block setu:size-4 setu:shrink-0 setu:rounded-full setu:!border setu:shadow-sm setu:transition-[color,box-shadow] setu:hover:ring-4 setu:focus-visible:ring-4 setu:focus-visible:outline-hidden setu:disabled:pointer-events-none setu:disabled:opacity-50"
                />
            ))}
        </SliderPrimitive.Root>
    );
}

export { Slider };
